import React, {useEffect, useState} from 'react';
import './EMDRControls.css';

const translations = {
  es: {
    start: 'START',
    stop: 'STOP',
    speed: 'Velocidad',
    size: 'Tamaño',
    repetitions: 'Repeticiones',
    sound: 'Sonido',
    tone: 'Tono',
    volume: 'Volumen',
    pattern: 'Trayectoria',
    comments: 'Comentarios',
    logout: 'Salir',
    language: 'Idioma',
    user: 'Usuario',
    hidePanel: 'Ocultar',
    showPanel: 'Mostrar'
  },
  en: {
    start: 'START',
    stop: 'STOP',
    speed: 'Speed',
    size: 'Size',
    repetitions: 'Repetitions',
    sound: 'Sound',
    tone: 'Tone',
    volume: 'Volume',
    pattern: 'Path',
    comments: 'Comments',
    logout: 'Logout',
    language: 'Language',
    user: 'User',
    hidePanel: 'Hide',
    showPanel: 'Show'
  },
  ar: {
    start: 'ابدأ',
    stop: 'توقف',
    speed: 'السرعة',
    size: 'الحجم',
    repetitions: 'التكرارات',
    sound: 'الصوت',
    tone: 'النغمة',
    volume: 'المستوى',
    pattern: 'المسار',
    comments: 'تعليقات',
    logout: 'خروج',
    language: 'اللغة',
    user: 'المستخدم',
    hidePanel: 'إخفاء',
    showPanel: 'إظهار'
  },
  fr: {
    start: 'DÉMARRER',
    stop: 'ARRÊTER',
    speed: 'Vitesse',
    size: 'Taille',
    repetitions: 'Répétitions',
    sound: 'Son',
    tone: 'Tonalité',
    volume: 'Volume',
    pattern: 'Trajet',
    comments: 'Commentaires',
    logout: 'Quitter',
    language: 'Langue',
    user: 'Utilisateur',
    hidePanel: 'Masquer',
    showPanel: 'Afficher'
  },
  pt: {
    start: 'INICIAR',
    stop: 'PARAR',
    speed: 'Velocidade',
    size: 'Tamanho',
    repetitions: 'Repetições',
    sound: 'Som',
    tone: 'Tom',
    volume: 'Volume',
    pattern: 'Trajeto',
    comments: 'Comentários',
    logout: 'Sair',
    language: 'Idioma',
    user: 'Usuário',
    hidePanel: 'Ocultar',
    showPanel: 'Mostrar'
  },
  de: {
    start: 'START',
    stop: 'STOPP',
    speed: 'Geschwindigkeit',
    size: 'Größe',
    repetitions: 'Wiederholungen',
    sound: 'Ton',
    tone: 'Tonhöhe',
    volume: 'Lautstärke',
    pattern: 'Pfad',
    comments: 'Kommentare',
    logout: 'Abmelden',
    language: 'Sprache',
    user: 'Benutzer',
    hidePanel: 'Ausblenden',
    showPanel: 'Anzeigen'
  },
  pl: {
    start: 'START',
    stop: 'STOP',
    speed: 'Prędkość',
    size: 'Rozmiar',
    repetitions: 'Powtórzenia',
    sound: 'Dźwięk',
    tone: 'Ton',
    volume: 'Głośność',
    pattern: 'Ścieżka',
    comments: 'Komentarze',
    logout: 'Wyloguj',
    language: 'Język',
    user: 'Użytkownik',
    hidePanel: 'Ukryj',
    showPanel: 'Pokaż'
  },
  it: {
    start: 'AVVIA',
    stop: 'STOP',
    speed: 'Velocità',
    size: 'Dimensione',
    repetitions: 'Ripetizioni',
    sound: 'Suono',
    tone: 'Tono',
    volume: 'Volume',
    pattern: 'Percorso',
    comments: 'Commenti',
    logout: 'Esci',
    language: 'Lingua',
    user: 'Utente',
    hidePanel: 'Nascondi',
    showPanel: 'Mostra'
  },
  ko: {
    start: '시작',
    stop: '정지',
    speed: '속도',
    size: '크기',
    repetitions: '반복',
    sound: '소리',
    tone: '톤',
    volume: '볼륨',
    pattern: '경로',
    comments: '댓글',
    logout: '로그아웃',
    language: '언어',
    user: '사용자',
    hidePanel: '숨기기',
    showPanel: '표시'
  },
  zh: {
    start: '开始',
    stop: '停止',
    speed: '速度',
    size: '大小',
    repetitions: '重复',
    sound: '声音',
    tone: '音调',
    volume: '音量',
    pattern: '路径',
    comments: '评论',
    logout: '退出',
    language: '语言',
    user: '用户',
    hidePanel: '隐藏',
    showPanel: '显示'
  },
  ja: {
    start: '開始',
    stop: '停止',
    speed: '速度',
    size: 'サイズ',
    repetitions: '繰り返し',
    sound: '音',
    tone: 'トーン',
    volume: '音量',
    pattern: '軌道',
    comments: 'コメント',
    logout: 'ログアウト',
    language: '言語',
    user: 'ユーザー',
    hidePanel: '非表示',
    showPanel: '表示'
  },
  he: {
    start: 'התחל',
    stop: 'עצור',
    speed: 'מהירות',
    size: 'גודל',
    repetitions: 'חזרות',
    sound: 'צליל',
    tone: 'טון',
    volume: 'עוצמה',
    pattern: 'מסלול',
    comments: 'תגובות',
    logout: 'יציאה',
    language: 'שפה',
    user: 'משתמש',
    hidePanel: 'הסתר',
    showPanel: 'הצג'
  },
  ru: {
    start: 'СТАРТ',
    stop: 'СТОП',
    speed: 'Скорость',
    size: 'Размер',
    repetitions: 'Повторы',
    sound: 'Звук',
    tone: 'Тон',
    volume: 'Громкость',
    pattern: 'Траектория',
    comments: 'Комментарии',
    logout: 'Выход',
    language: 'Язык',
    user: 'Пользователь',
    hidePanel: 'Скрыть',
    showPanel: 'Показать'
  }
};

const EMDRControls = ({
  emdrActive,
  setEmdrActive,
  emdrSpeed,
  setEmdrSpeed,
  emdrSize,
  setEmdrSize,
  emdrRepetitions,
  setEmdrRepetitions,
  emdrPattern,
  setEmdrPattern,
  soundEnabled,
  setSoundEnabled,
  soundTone,
  setSoundTone,
  soundVolume,
  setSoundVolume,
  onShowFeedback,
  onLogout,
  currentUser,
  language,
  onLanguageChange,
}) => {
  const t = translations[language] || translations.es;
  const [panelHidden, setPanelHidden] = useState(false);
  const toggleEMDR = () => {
    setEmdrActive(!emdrActive);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === 'Space' || event.key === ' ') {
        event.preventDefault();
        setEmdrActive(!emdrActive);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [emdrActive, setEmdrActive]);

  return (
    <div className="emdr-controls-wrapper">
      {/* Controles EMDR */}
      <div className={`emdr-controls-container ${panelHidden ? 'panel-hidden' : ''}`}>
        
        <div className="panel-content">
          <div className="emdr-button-container hide-when-collapsed">
            <button
              className={`button emdr-button ${emdrActive ? 'stop-button' : 'start-button'}`}
              onClick={toggleEMDR}
              title={emdrActive ? 'Detener' : 'Iniciar'}>
              {emdrActive ? '⏸' : '▶'}
            </button>
            <span className="emdr-button-label">
              {emdrActive ? t.stop : t.start}
            </span>
          </div>

          <div className="control-group pattern-control hide-when-collapsed">
            <div className="pattern-buttons">
              <button
                className={`button small-button pattern-button ${emdrPattern === 'horizontal' ? 'active' : ''}`}
                onClick={() => setEmdrPattern('horizontal')}
                title="Horizontal"
              >
                ↔
              </button>
              <button
                className={`button small-button pattern-button ${emdrPattern === 'diagonal-right' ? 'active' : ''}`}
                onClick={() => setEmdrPattern('diagonal-right')}
                title="Diagonal ↗"
              >
                ↗
              </button>
              <button
                className={`button small-button pattern-button ${emdrPattern === 'diagonal-left' ? 'active' : ''}`}
                onClick={() => setEmdrPattern('diagonal-left')}
                title="Diagonal ↘"
              >
                ↘
              </button>
            </div>
            <span className="control-label">{t.pattern}</span>
          </div>

          <div className="control-panel hide-when-collapsed">
            <div className="control-group wide-control">
              <div className="control-track">
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    const newSpeed = Math.max(0, emdrSpeed - 10);
                    setEmdrSpeed(newSpeed);
                  }}>
                  −
                </button>
                <input
                  type="range"
                  className="control-slider"
                  min="0"
                  max="100"
                  step="1"
                  value={emdrSpeed}
                  onChange={(e) => setEmdrSpeed(parseInt(e.target.value, 10))}
                  aria-label="Velocidad"
                />
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    const newSpeed = Math.min(100, emdrSpeed + 10);
                    setEmdrSpeed(newSpeed);
                  }}>
                  +
                </button>
              </div>
              <span className="control-label">{t.speed} {emdrSpeed}%</span>
            </div>

            <div className="control-group wide-control">
              <div className="control-track">
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    const newSize = Math.max(20, emdrSize - 10);
                    setEmdrSize(newSize);
                  }}>
                  −
                </button>
                <input
                  type="range"
                  className="control-slider"
                  min="20"
                  max="300"
                  step="1"
                  value={emdrSize}
                  onChange={(e) => setEmdrSize(parseInt(e.target.value, 10))}
                  aria-label="Tamaño"
                />
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    const newSize = Math.min(300, emdrSize + 10);
                    setEmdrSize(newSize);
                  }}>
                  +
                </button>
              </div>
              <span className="control-label">{t.size} {emdrSize}px</span>
            </div>
          </div>

          <div className="control-panel hide-when-collapsed">
            <div className="control-group wide-control">
              <div className="control-track">
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    if (emdrRepetitions === null) {
                      // Si está en infinito, cambiar a 1
                      setEmdrRepetitions(1);
                    } else if (emdrRepetitions > 0) {
                      // Si es mayor a 0, restar 1
                      setEmdrRepetitions(emdrRepetitions - 1);
                    }
                  }}
                  disabled={emdrRepetitions === null || emdrRepetitions <= 0}>
                  −
                </button>
                <input
                  type="number"
                  className="repetitions-input"
                  value={emdrRepetitions === null ? '∞' : emdrRepetitions.toString()}
                  onChange={(e) => {
                    const value = e.target.value.trim();
                    if (value === '' || value === '∞') {
                      setEmdrRepetitions(null);
                    } else {
                      const num = parseInt(value, 10);
                      if (!isNaN(num) && num >= 0) {
                        setEmdrRepetitions(num);
                      } else {
                        // Si el valor no es válido, restaurar el valor anterior
                        e.target.value = emdrRepetitions === null ? '∞' : emdrRepetitions.toString();
                      }
                    }
                  }}
                  onBlur={(e) => {
                    // Si está vacío al perder el foco, poner 0
                    if (e.target.value === '' || e.target.value === '∞') {
                      if (emdrRepetitions === null) {
                        e.target.value = '∞';
                      } else {
                        e.target.value = emdrRepetitions.toString();
                      }
                    }
                  }}
                  placeholder="0"
                  min="0"
                />
                <input
                  type="range"
                  className="control-slider"
                  min="0"
                  max="60"
                  step="1"
                  value={emdrRepetitions === null ? 0 : emdrRepetitions}
                  onChange={(e) => setEmdrRepetitions(parseInt(e.target.value, 10))}
                  disabled={emdrRepetitions === null}
                  aria-label="Repeticiones"
                />
                <button
                  className="button small-button secondary-button"
                  onClick={() => {
                    if (emdrRepetitions === null) {
                      // Si está en infinito, cambiar a 1
                      setEmdrRepetitions(1);
                    } else {
                      // Incrementar el valor
                      setEmdrRepetitions(emdrRepetitions + 1);
                    }
                  }}>
                  +
                </button>
                <button
                  className={`button small-button ${emdrRepetitions === null ? 'active' : ''}`}
                  onClick={() => {
                    // Alternar entre infinito y el valor actual
                    if (emdrRepetitions === null) {
                      // Si está en infinito, cambiar a 0
                      setEmdrRepetitions(0);
                    } else {
                      // Cambiar a infinito
                      setEmdrRepetitions(null);
                    }
                  }}
                  title={emdrRepetitions === null ? 'Cambiar a número fijo' : 'Cambiar a infinito'}>
                  ∞
                </button>
              </div>
              <span className="control-label">{t.repetitions}</span>
            </div>
          </div>

          <div className="sound-panel hide-when-collapsed">
          <div className="control-group sound-toggle">
            <button
              className={`button small-button ${soundEnabled ? 'active sound-button-active' : 'sound-button'}`}
              onClick={() => setSoundEnabled(!soundEnabled)}
              title={soundEnabled ? 'Desactivar sonido' : 'Activar sonido'}>
              🔊
            </button>
            <span className="control-label">{t.sound}</span>
          </div>

          <div className={`control-group wide-control ${soundEnabled ? '' : 'sound-controls-disabled'}`}>
            <div className="control-track">
              <button
                className="button small-button secondary-button"
                onClick={() => {
                  const newTone = Math.max(400, soundTone - 50);
                  setSoundTone(newTone);
                }}
                disabled={!soundEnabled}>
                −
              </button>
              <input
                type="range"
                className="control-slider compact"
                min="400"
                max="2000"
                step="10"
                value={soundTone}
                onChange={(e) => setSoundTone(parseInt(e.target.value, 10))}
                aria-label="Tono"
                disabled={!soundEnabled}
              />
              <button
                className="button small-button secondary-button"
                onClick={() => {
                  const newTone = Math.min(2000, soundTone + 50);
                  setSoundTone(newTone);
                }}
                disabled={!soundEnabled}>
                +
              </button>
            </div>
            <span className="control-label">{t.tone} {soundTone}Hz</span>
          </div>

          <div className={`control-group wide-control ${soundEnabled ? '' : 'sound-controls-disabled'}`}>
            <div className="control-track">
              <button
                className="button small-button secondary-button"
                onClick={() => {
                  const newVolume = Math.max(0, soundVolume - 5);
                  setSoundVolume(newVolume);
                }}
                disabled={!soundEnabled}>
                −
              </button>
              <input
                type="range"
                className="control-slider compact"
                min="0"
                max="100"
                step="1"
                value={soundVolume}
                onChange={(e) => setSoundVolume(parseInt(e.target.value, 10))}
                aria-label="Volumen"
                disabled={!soundEnabled}
              />
              <button
                className="button small-button secondary-button"
                onClick={() => {
                  const newVolume = Math.min(100, soundVolume + 5);
                  setSoundVolume(newVolume);
                }}
                disabled={!soundEnabled}>
                +
              </button>
            </div>
            <span className="control-label">{t.volume} {soundVolume}%</span>
          </div>
          </div>

          <div className="user-lang hide-when-collapsed">
            <label className="language-label">
              {t.language}
              <select
                className="language-select"
                value={language}
                onChange={(e) => onLanguageChange && onLanguageChange(e.target.value)}
                aria-label={t.language}
              >
                <option value="es">Español</option>
                <option value="en">English</option>
                <option value="ar">العربية</option>
                <option value="fr">Français</option>
                <option value="pt">Português</option>
                <option value="de">Deutsch</option>
                <option value="pl">Polski</option>
                <option value="it">Italiano</option>
                <option value="ko">한국어</option>
                <option value="zh">中文</option>
                <option value="ja">日本語</option>
                <option value="he">עברית</option>
                <option value="ru">Русский</option>
              </select>
            </label>
          </div>
          {/* Botones de acción adicionales */}
          <div className="action-buttons-group action-right">
            <div className="control-group hide-when-collapsed">
              <button
                className="button small-button feedback-button action-button"
                onClick={() => onShowFeedback && onShowFeedback()}
                title="Enviar comentarios">
                💬
              </button>
              <span className="control-label">{t.comments}</span>
            </div>
            {onLogout && (
              <div className="control-group hide-when-collapsed">
                <button
                  className="button small-button logout-button action-button"
                  onClick={() => onLogout && onLogout()}
                  title="Cerrar sesión">
                  {t.logout}
                </button>
                <span className="control-label">{t.logout}</span>
              </div>
            )}
            <div className="control-group panel-toggle-group">
              <button
                className="button small-button action-button panel-toggle-button"
                onClick={() => setPanelHidden(!panelHidden)}
                title={panelHidden ? t.showPanel : t.hidePanel}
              >
                {panelHidden ? '▾' : '▴'}
              </button>
              <span className="control-label">{panelHidden ? t.showPanel : t.hidePanel}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EMDRControls;
